import { call, put, takeLatest } from 'redux-saga/effects';
import {
  downloadJsonFileWithUrl,
  handleGeneralGET,
  handleGeneralGETFnType,
} from 'utils/saga-helper/generalRequest';
import fetchClient from 'utils/requestInterceptor';
import { PayloadAction } from '@reduxjs/toolkit';
import { CompanyDetail, SsoConfiguration } from '../../../../types/models';
import { companyDetailPageActions as actions } from '.';
import { paginationActions } from '../../../components/Pagination/slice';
import { API_ENDPOINTS } from 'utils/configs';
import {
  UpdateCompanyDetailAction,
  CreateCompanyAction,
  DeleteCompanyAction,
  UploadSSOConfigAction,
} from './types';
import {
  displayError,
  displaySuccessToaster,
} from 'app/components/ToasterBar/helpers';
import { CompanyToasterMsg } from '../../../components/ToasterBar/constants';
import { history } from '../../../../utils/history';
import { UrlToCompany } from '../../../constants';

export function* fetchCompanyDetailSaga(action: PayloadAction<string>) {
  yield call<handleGeneralGETFnType<CompanyDetail>>(
    handleGeneralGET,
    actions.fetchCompanyDetailSucceeded,
    actions.fetchCompanyDetailFailed,
    API_ENDPOINTS.COMPANY + action.payload,
  );
}

export function* createCompanySaga(action: PayloadAction<CreateCompanyAction>) {
  try {
    const { data }: { data: CompanyDetail } = yield call(
      fetchClient.post,
      API_ENDPOINTS.COMPANY,
      action.payload.companyDetail,
    );
    yield put(actions.createCompanySucceeded(data));
    yield call(displaySuccessToaster, CompanyToasterMsg.CREATE_COMPANY_SUCCEED);
    yield call(history.push, UrlToCompany(data.id).detail);
  } catch (err) {
    yield call(displayError, err);
  }
}

export function* deleteCompanySaga(action: PayloadAction<DeleteCompanyAction>) {
  try {
    yield call(
      fetchClient.delete,
      API_ENDPOINTS.COMPANY + action.payload.companyId,
    );
    yield put(actions.cleanup());
    yield call(displaySuccessToaster, CompanyToasterMsg.DELETE_COMPANY_SUCCEED);
    yield put(
      paginationActions.initPageData({
        filters: '',
        sorts: '',
        page: 0,
        page_size: 20,
        path: `${API_ENDPOINTS.COMPANIES}`,
        pagiType: 'pagiCompany',
      }),
    );
  } catch (err) {
    yield call(displayError, err);
  }
}

export function* downloadSsoConfigSaga(action: PayloadAction<string>) {
  try {
    const { data }: { data: SsoConfiguration } = yield call(
      fetchClient.get,
      API_ENDPOINTS.COMPANY +
        action.payload +
        API_ENDPOINTS.DOWNLOAD_SSO_CONFIG,
    );
    yield put(
      actions.downloadSSOConfigSucceeded({
        ...data,
        company_id: action.payload,
      }),
    );
  } catch (err) {
    yield call(displayError, err);
    yield put(actions.downloadSSOConfigFailed());
  }
}

export function* downloadSSOConfigSucceededSaga(
  action: PayloadAction<SsoConfiguration>,
) {
  yield call(
    downloadJsonFileWithUrl,
    action.payload.direct_url!,
    `${action.payload.company_id}_connection_details.json`,
  );
}

export function* updateCompanyDetailSaga(
  action: PayloadAction<UpdateCompanyDetailAction>,
) {
  try {
    const { data }: { data: CompanyDetail } = yield call(
      fetchClient.put,
      API_ENDPOINTS.COMPANY + action.payload.id,
      action.payload.updatedCompanyDetail,
    );
    yield put(actions.updateCompanyDetailSucceeded(data));
    yield call(
      displaySuccessToaster,
      CompanyToasterMsg.UPDATE_COMPANY_DETAIL_SUCCEED,
    );
  } catch (err) {
    yield call(displayError, err);
  }
}

export function* uploadSSOConfigSaga(
  action: PayloadAction<UploadSSOConfigAction>,
) {
  try {
    const { data }: { data: SsoConfiguration } = yield call(
      fetchClient.post,
      API_ENDPOINTS.COMPANY +
        action.payload.companyId +
        API_ENDPOINTS.UPLOAD_SSO_CONFIG,
      action.payload.ssoConfig,
    );
    yield put(actions.uploadSSOConfigSucceeded(data));
  } catch (err) {
    yield put(actions.uploadSSOConfigFailed());
    yield call(displayError, err);
  }
}

export function* companyDetailPageSaga() {
  yield takeLatest(actions.createCompany.type, createCompanySaga);
  yield takeLatest(actions.deleteCompany.type, deleteCompanySaga);
  yield takeLatest(actions.downloadSSOConfig.type, downloadSsoConfigSaga);
  yield takeLatest(
    actions.downloadSSOConfigSucceeded.type,
    downloadSSOConfigSucceededSaga,
  );
  yield takeLatest(actions.fetchCompanyDetail.type, fetchCompanyDetailSaga);
  yield takeLatest(actions.updateCompanyDetail.type, updateCompanyDetailSaga);
  yield takeLatest(actions.uploadSSOConfig.type, uploadSSOConfigSaga);
}
